import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import UpdatePortfolioDetail from '../../components/admincomponents/UpdatePortfolioDetail';

function UpdateBlog({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <UpdatePortfolioDetail />            
    </>
  );
}

export default UpdateBlog;
